<template>
    <app-field :error="error" :classes="classes" :append="append">
        <app-label v-if="label != ''" :label="label" :required="required" :description="description"></app-label>

        <app-money
            v-model="content"
            class="input"
            :class="options"
            v-bind="$attrs"
            slot="input"
        />
    </app-field>
</template>

<script>
    /* Components */
    import Field from '@/components/fields/Field';
    import Label from '@/components/fields/Label';
    import {Money} from 'v-money'

    export default {
        name: 'app-field-text',
        components: {
            'app-field': Field,
            'app-label': Label,
            'app-money': Money
        },
        props: {
            label: {
                type: String,
                default: ''
            },
            required: {
                type: Boolean,
                default: false
            },
            description: {
                type: String,
                default: ''
            },
            error: {
                type: String,
                default: ''
            },
            value: {
                default: ''
            },
            classes: {
                type: Object,
                default: () => ({})
            },
            append: {
                type: String,
                default: ''
            }
        },

        data: () => ({
            content: ''
        }),

        mounted() {
            this.content = this.value ? this.value : '';
        },

        computed: {
            options() {
                let classes = {};
                if(typeof this.classes.input != 'undefined' && Object.keys(this.classes.input).length > 0) {
                    classes = {
                        ...this.classes.input
                    };
                }
                if(this.error != '') {
                    classes['error'] = true;
                }
                return classes;
            }
        },

        methods: {
            update() {
                this.$emit('input', this.content)
            }
        },

        watch: {
            content() {
                this.update();
            }
        }
    }
</script>

<style lang="scss">
    @import '../../../sass/modules/inputs.scss';
</style>



// WEBPACK FOOTER //
// src/components/fields/inputs/Currency.vue